<template>
  <v-app>
  <v-content>

    <!-- Call to action TOP -->
    <v-img
      :src="headerImage"
      gradient="to top right, rgba(63,81,181, .3), rgba(25,32,72, .2)"
      position="center center"
      height="400"
    >
      <v-container fill-height>
        <v-layout align-center>
          <v-flex>
            <h1 class="display-3 white--text">KNOWMAK<br>Explore Knowledge Production in Europe</h1>
            <v-btn large color="primary" class="mx-0 space-button" slot="activator" @click="$vuetify.goTo('#datastories', {offset: 0, duration: 600, easing: 'easeInOutCubic'})">Study data stories</v-btn>
            <v-btn
              large
              slot="activator"
              to="/dashboard"
              class="mx-0 hidden-sm-and-down"
              color="primary"
            >
              Dive right in!</v-btn>
            <v-tooltip
              sm
              bottom
              max-width=200
              color="warning"
              class="hidden-md-and-up"
              v-model="showWarning.btn1"
              content-class="mobile_warning"
            >
              <v-btn
                large
                slot="activator"
                class="mx-0"
                color="primary"
                @click="toggleWarning('btn1')"
              >
                Dive right in!</v-btn>
              <span>{{ mobileWarning }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>

    <!-- Icons Grid -->
    <v-content>
      <v-container
        fluid
        fill-height
        pt-5
        pb-4
      >
        <v-layout
          row
          wrap
          align-start
          justify-space-around
          px-5
          pt-4
        >
          <v-flex
            xs12
            sm4
            v-for="t in taglines"
            :key="t.icon"
            pb-3
            mb-4
          >
            <v-card
              color="transparent"
              class="text-xs-center"
              flat
            >
              <v-img
                height="5rem"
                contain
              >
                <v-flex align="center">
                  <font-awesome-icon class="icon" :icon="t.icon" />
                </v-flex>
              </v-img>
              <v-card-title
                class="headline justify-center"
              >
                {{ t.headline }}
              </v-card-title>
              <v-card-text>
                  {{ t.content }}
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <!-- Data Stories -->
    <v-content id="datastories">
      <v-container
        white
        fill-height
        fluid
        :class="{'px-0': $vuetify.breakpoint.smAndUp }"
        py-0
      >
        <v-layout row wrap align-center>
          <v-content v-for="(story, index) in newestDataStories" :key="index">
            <data-story :datastory="story" :reversing='(index%2) == 0 ? true : false'>
            </data-story>
          </v-content>
        </v-layout>
      </v-container>
    </v-content>

    <!--Testimonials-->
    <!--<v-content>-->
      <!--<v-container-->
        <!--fluid-->
        <!--fill-height-->
        <!--my-3-->
      <!--&gt;-->
        <!--&lt;!&ndash; use my-5 for v-container once testimonials are used -&ndash;&gt;-->
        <!--<v-layout-->
          <!--row-->
          <!--wrap-->
          <!--align-start-->
          <!--justify-space-around-->
          <!--px-5-->
          <!--pb-1-->
        <!--&gt;-->
          <!--<v-flex xs12 class="display-1" px-5>-->
            <!--What users are saying...-->
          <!--</v-flex>-->
          <!--<v-flex-->
            <!--xs12-->
            <!--md4-->
            <!--px-5-->
            <!--mb-4-->
            <!--v-for="testimonial in testimonials"-->
            <!--:key="testimonial.img"-->
          <!--&gt;-->
            <!--<v-card-->
              <!--flat-->
              <!--color="transparent"-->
            <!--&gt;-->
              <!--<v-img-->
                <!--height="19em"-->
                <!--:src="require('@/assets/img/landingpage/' + testimonial.photo + '')"-->
              <!--&gt;-->
              <!--</v-img>-->
              <!--<v-card-title class="title pb-0 px-0">-->
                <!--{{ testimonial.name }}-->
              <!--</v-card-title>-->
              <!--<v-card-text class="px-0">-->
                <!--&ldquo;{{ testimonial.quote }}&rdquo;-->
              <!--</v-card-text>-->
            <!--</v-card>-->
          <!--</v-flex>-->
        <!--</v-layout>-->
      <!--</v-container>-->
    <!--</v-content>-->

    <!-- spacer -->
    <!--<v-content>-->
      <!--<v-container-->
        <!--fluid-->
        <!--fill-height-->
        <!--class="white"-->
      <!--&gt;</v-container>-->
    <!--</v-content>-->

    <!-- Data Stories Archive -->
    <story-archive id="datastories-archive" :archived-stories="dataStoriesArchive">

    </story-archive>

    <!-- Call to Action BOTTOM -->
    <v-img
      :src="footerImage"
      gradient="to top right, rgba(63,81,181, .3), rgba(25,32,72, .2)"
      height="400"
    >
      <v-container fill-height>
        <v-layout align-center>
          <v-flex>
            <h3 class="display-1 white--text">Interested?</h3>
            <h3 class="display-1 white--text">Start your own exploration now!</h3>
            <v-btn
              large
              slot="activator"
              to="/dashboard"
              class="mx-0 hidden-sm-and-down"
              color="primary"
            >
              Try it out</v-btn>
            <v-tooltip
              bottom
              max-width=200
              color="warning"
              class="hidden-md-and-up"
              v-model="showWarning.btn2"
              content-class="mobile_warning"
            >
              <v-btn
                large
                slot="activator"
                @click="toggleWarning('btn2')"
                class="mx-0"
                color="primary"
              >Try it out</v-btn>
              <span>{{ mobileWarning }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>

    <!-- Partner logos -->
    <!--
    <v-container
      fluid
      :class="{'px-0': $vuetify.breakpoint.smAndUp }"
      grid-list-md
      pa-5
    >
      <v-layout
        align-center
        justify-center
      >
        <v-flex
          row wrap
          xs6 sm3 lg1
          class="align-center text-xs-center"
          v-for="(partner, index) in partnerLogos"
          :key="index"
        >
          <a :href="partner.url">
            <img :src="require('@/assets/img/logos_partners/' + partner.logo + '')" :alt="'Logo of ' + partner.name" height="100%" width="100%">
          </a>
        </v-flex>
      </v-layout>
    </v-container>
    -->

    <!-- Footer with links to knowmak.eu + EU logo -->
    <v-footer
      height="auto"
      class="grey lighten-2"
    >
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <!-- KNOWMAK info links -->
          <v-card
            flat
            tile
            class="text-xs-center"
          >
            <v-card-text>
              <v-btn
                color="euflag"
                flat
                v-for="(w, i) in weblinks"
                :key="i"
                :href="w.url"
                target="_blank"
              >
                {{ w.label }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 justify-center color="grey lighten-2">
          <v-content
            color="grey lighten-2"
          >
          <!-- EU logo, project logo -->
          <v-container
            fluid
            text-xs-center
          >
            <v-layout row wrap align-center justify-center pt-2 text-xs-center>
              <v-flex pa-1 xs12 sm3 md3 lg2 xl1>
                <v-card
                  flat
                  tile
                  color="transparent"
                  height="60px"
                >
                  <v-img
                    contain
                    height="60px"
                    href="#"
                    :src="require('@/assets/img/logos/eu_flag.svg')"
                  >
                  </v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container pt-0 class="euflag--text" text-xs-center caption>
              This project has received funding from the European Union's Horizon 2020 research and innovation programme under grant agreement No. 726992
          </v-container>
          </v-content>

        </v-flex>
      </v-layout>
    </v-footer>
  </v-content>
  </v-app>
</template>

<script>
import 'jquery'
import DataStory from './DataStory'
import StoryArchive from './StoryArchive'
import datastoryJSON from '../assets/data/datastories.json'
import partners from '../assets/data/partners.json'
import testimonials from '../assets/data/testimonials.json'

export default {
  data: () => ({
    weblinks: [
      {
        label: 'About KNOWMAK',
        url: 'https://project.knowmak.eu/about/project-overview/'
      },
      {
        label: 'About RISIS',
        url: 'https://www.risis2.eu/about/'
      },
      {
        label: 'legal information',
        url: 'https://project.knowmak.eu/legal-information'
      }
    ],
    taglines: [
      {
        icon: 'lightbulb',
        headline: 'A wealth of knowledge',
        content: 'Combine multiple data sources (publications, patents, European projects).'
      },
      {
        icon: 'globe',
        headline: 'Connect the dots',
        content: 'Analyse knowledge production by topics and geography.'
      },
      {
        icon: 'chart-area',
        headline: 'Interactive visualisations',
        content: 'Pick from different kinds of visualisation options for the data you are interested in.'
      }
    ],
    mobileWarning: 'Please be aware KNOWMAK is not optimised for small screens and might not work properly on your mobile device',
    showWarning: {
      btn1: false,
      btn2: false
    }
  }),
  components: {
    DataStory,
    StoryArchive
  },
  methods: {
    toggleWarning (btn) {
      if (this.showWarning[btn] === false) {
        this.showWarning[btn] = !this.showWarning[btn]
      } else {
        this.showWarning[btn] = !this.showWarning[btn]
        this.$router.push({ path: '/dashboard' })
      }
    }
  },
  computed: {
    dataStoriesArchive () {
      let archivedStories = this.publishedDataStories
      archivedStories = archivedStories.reverse().slice(3)

      return archivedStories
    },
    publishedDataStories () {
      // get only active Data Stories
      let allStories = datastoryJSON.filter(function (s) {
        if (s.online === true) {
          return s
        }
      }).sort(function (a, b) {
        return a.id - b.id
      })

      return allStories
    },
    newestDataStories () {
      // newest data story is displayed as first/topmost
      let landingPageStories = this.publishedDataStories
      return landingPageStories.slice(-3).reverse()
    },
    partnerLogos () {
      return partners
    },
    testimonials () {
      return testimonials
    },
    headerImage () {
      return require('../assets/img/landingpage/bg-collaboration-with-risis-logo-cr.jpg')
    },
    footerImage () {
      return require('../assets/img/landingpage/bg-collaboration.jpg')
    },
    iconGrid () {
      const iconGridLayout = {}
      if (this.$vuetify.breakpoint.smAndDown) {
        iconGridLayout.column = true
      }
      return iconGridLayout
    },
    dataStoriesGrid () {
      const dsLayout = {}
      if (this.$vuetify.breakpoint.smAndDown) {
        dsLayout.column = true
      }
      return dsLayout
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/landing-page.css';

  .space-button {
    margin-right: 8px!important;
  }

  @media screen and (max-width: 480px) {
    .display-3 {
      font-size: 40px !important;
    }

    .space-button {
      margin-top: 15px!important;
    }
  }

  #datastories-archive >>> [role="combobox"] {
    display: none;
  }

</style>

<style>
  .mobile_warning {
    opacity: 1!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue